<template>
  <div class="container" :style="{ height: windowHeight + 'px' }">
    <!-- <van-nav-bar
      title="领取成功"
      left-text=""
      left-arrow
      fixed
      placeholder
      @click-left="onClickLeft"
    /> -->

    <div class="box">
      <van-icon name="bag" size="50" color="#f391a9" />
      <div>
        <p>领取成功！</p>
        <p>请耐心等待商家发货</p>
        <van-button
          class="btn"
          color="#f47920"
          round
          plain
          @click="continueReceive"
          >继续领取</van-button
        >&emsp;
        <van-button class="btn" color="#d64f44" round @click="checkOrder"
          >查看订单</van-button
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      windowHeight: document.documentElement.clientHeight, //实时屏幕高度
    };
  },

  components: {},

  computed: {},

  mounted() {},

  methods: {
    onClickLeft() {
      this.$router.replace({
        path: "/searchResult",
        query: { voucherCode: this.$route.query.voucherCode },
      });
    },
    continueReceive() {
      this.$router.replace({
        path: "/customerSearch",
      });
    },
    checkOrder() {
      this.$router.replace({
        path: "/orderDetails",
        query: { voucherCode: this.$route.query.voucherCode,isShowReceive:true },
      });
    },
  },
};
</script>
<style lang='scss' scoped>
.container {
  width: 100%;
  background-color: rgba(247, 243, 249, 1);
  .box {
    border-radius: 5%;
    position: absolute;
    background-color: white;
    width: 90%;
    left: 5%;
    margin: 10px 0 0 0;
    .btn {
      margin: 0 0 20px 0;
    }
  }
}
</style>